<div class="modal-header">
    <h2 class="modal-title" translate="Settings.AccountSecuritySection.Dialog.EnableSecurityKey"></h2>
</div>

<app-enable-security-key-info *ngIf="step === 1" (close)="close();" ></app-enable-security-key-info>

<app-enable-security-key-ready *ngIf="step === 2" (close)="close();"></app-enable-security-key-ready>